module.exports = __webpack_public_path__ + "img/chalalit_yes.596b6498.png";